import Vue from 'vue';  
import router from '../router';
import { store } from '../store'; 
import {EventBus} from './eventBus'; 
import {TextBus} from './textBus'; 
import {ActionBus} from './actionBus'; 

import {DateBus} from './dateBus'; 
import DATA from './DATA'     
import formatNumber, { toMoney }  from './formatNumber'     
import { generateInvoicePayload,toJulianDate,calculateVAT,decryptInvoiceNumber } from './mra_eis';
import moment from 'moment';
const toNumber=formatNumber.toNumber
const NAME = "EIS-BUS"

export const EisBus = new Vue({
    data(){
        return{ 
            scrolled:0,  
        }
    },
    computed:{ 
        app(){
            return store?.getters?.getApp
        },   
        us(){
            let returnUser = store?.getters?.getUser
            return returnUser
        },  
        ud(){
            let returnUser = store?.getters.getUserDetails
            return returnUser
        }, 
        loading(){ 
            const loading = store?.getters.getLoading
            return loading
        },
        processes(){ 
            const process = store?.getters.getProcesses
            return process
        }, 
        responses(){ 
            const re = store?.getters.getResponses
            return re
        },  

        CompanySettings(){ 
            const re = store?.state.items[(DATA.ITEMS.COMPANY_SETTINGS.values).toUpperCase()]
            return re
        },
        selectedCompany(){ 
            const re = store?.getters.getSelectedCompany
            return re
        },
        stockOutlets(){  
            const outlet = store?.getters.getStockOutlets
            return outlet
        },  
        tills(){  
            const tills = store?.getters.getTills
            return tills
        }, 
        getStockOutlet(){   
            return (key,code)=>{
                if (key) {
                    return store?.getters?.getStockOutletByKey(key) 
                }
                return store?.getters?.getStockOutletByCode(code) 
            }
        },  
        getTill(){  
            const tills = store?.getters.getTills
            return (key,code)=>{
                if (key) {
                    return store?.getters?.getTillByKey(key) 
                }
                return store?.getters?.getTillByCode(code) 
            }
        },  
        
    },
    created(){
        EventBus.$on('DIALOG_YES',this.DIALOG_YES)  
    },
    mounted(){ 
 
    },
    methods:{ 
        RESET_ALL_DATA(){ 
            try { 
                Object.assign(this.$data, this.$options.data())  
            } catch (error) {
                this.error({
                    error:error,
                    from:'RESET_ALL_DATA',
                    page:PAGE_NAME, 
                }) 
            }
        },
        error(error){
            try {
                if(!error){return}
                let err = error.error?error.error:'...'
                let from = error.from?error.from:'...'
                let page = error.page?error.page:'...'
                store.dispatch('ERROR',{
                    error:err,
                    from:from,
                    page:page
                }) 
            } catch (error) {
                this.error({
                    error:error,
                    from:'error',
                    page:NAME, 
                })
            }
        }, 

        ON_SYNC_EIS_PRODUCTS(payload){
            return new Promise(async (resolve,reject)=>{
                try {
                    const {
                        till_code,
                        till_key,
                        stock_outlet_code,
                        stock_outlet_key,
                        confirm
                    } = payload || {} 
                    const selectedCompany = this.selectedCompany           
                    const company_key = selectedCompany?selectedCompany.company_key:null 
                    let upload_till_key = null
    
                    if (till_key) {
                        upload_till_key = till_key
                    }else if (till_code) {
                        const till = this.getTill(null,till_code)
                        upload_till_key = till?.key
                    } else if (stock_outlet_code||stock_outlet_key) {
                        let search_outlet_code = null
                        if (stock_outlet_code) {
                            search_outlet_code =  stock_outlet_code 
                        } else if (stock_outlet_key) {
                            const search_outlet = this.getStockOutlet(stock_outlet_key)
                            search_outlet_code = search_outlet?.code
                        }   
                        if (search_outlet_code) {
                            const tills = this.tills 
                            const till = tills?.find(i=>i.outlet_code==search_outlet_code && i.eis_terminal) 
                            upload_till_key = till?.key 
                        }
                    }  
                    const upload_data = {
                        company_key,
                        till_key:upload_till_key,
                        production:DATA.EIS.production
                    } 
                    if (confirm) { 
                        let mbs_text = TextBus.item_action("EIS Products","SYNC")
                        ActionBus.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo,
                            action:{
                                code:NAME+"=SYNC-EIS-PRODUCTS", 
                                data:{
                                    ...payload,
                                    upload_data
                                }
                            } 
                        }) 
                        resolve({
                            success:true,
                            wait_for_conformation:true
                        }) 
                        return
                    }  
                    const res = await this.SYNC_EIS_PRODUCTS({
                        ...payload,
                        upload_data
                    })
                    console.log(res,"ON_SYNC_EIS_PRODUCTS............re");
                     

                    resolve(res)
                    return
                } catch (error) { 
                    console.log(error,"ON_SYNC_EIS_PRODUCTS............er");
                    reject(error)
                    return  
                }

            })
        }, 
        SYNC_EIS_PRODUCTS(data){
            return new Promise(async (resolve,reject)=>{
                try {  
                    const upload_data ={
                        path:"sync-mra-items-to-inventory",
                        is_full_path:false,
                        data:data?.upload_data
                    } 
                    this.inputLoading = true 
                    if (data?.notify) {
                        ActionBus.progressDialog({
                            show:true,
                            fixed:false,
                            title:"Reloading.."
                        })  
                    }
                    const res = await ActionBus.POST_REQUEST(upload_data)
                    const body = res?.body
                    const message = body?.message 
                    this.inputLoading = false
                    ActionBus.progressDialog() 
                    if (data?.notify) {
                        let mbs_text = TextBus.item_action_success("Eis products","Syncing")
                        ActionBus.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:`${mbs_text.text} (${message})`,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        }) 
                    } 
                    resolve(res)
                } catch (error) { 
                    this.inputLoading = false
                    const body = error?.body
                    const message = body?.message
                    ActionBus.progressDialog() 
                    if (data?.notify) {
                        let mbs_text = TextBus.item_action_fail("Eis products","Syncing")
                        ActionBus.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:mbs_text.text+" ("+message+")",
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        }) 
                    }
                    reject(error)
                } 

            }) 
        },
        ON_EIS_SYNC_INVENTORIES(payload){
            return new Promise(async (resolve,reject)=>{
                try {
                    let {
                        till_keys,
                        outlet_keys,
                        sync_all,
                        update_name_by_description,update_name_by_name,pricing_tiers,
                        confirm
                    } = payload || {} 
                    const selectedCompany = this.selectedCompany           
                    const company_key = selectedCompany?selectedCompany.company_key:null 
                    if (!till_keys && !outlet_keys && !sync_all) {
                        sync_all = true
                    }  
                    const upload_data = {
                        company_key,
                        till_keys,outlet_keys,sync_all,
                        update_name_by_description,update_name_by_name,pricing_tiers,
                        production:DATA.EIS.production
                    } 
                    if (confirm) { 
                        let mbs_text = TextBus.item_action("EIS Inventories","SYNC")
                        ActionBus.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo,
                            action:{
                                code:NAME+"=SYNC-EIS-INVENTORIES", 
                                data:{
                                    ...payload,
                                    upload_data
                                }
                            } 
                        }) 
                        resolve({
                            success:true,
                            wait_for_conformation:true
                        }) 
                        return
                    }  
                    const res = await this.SYNC_EIS_INVENTORIES({
                        ...payload,
                        upload_data
                    })
                    console.log(res,"ON_SYNC_EIS_INVENTORIES............re");
                     

                    resolve(res)
                    return
                } catch (error) { 
                    console.log(error,"ON_EIS_SYNC_INVENTORIES............er");
                    reject(error)
                    return  
                }

            })
        }, 
        SYNC_EIS_INVENTORIES(data){
            return new Promise(async (resolve,reject)=>{
                try {  
                    const upload_data ={
                        path:"eis-sync-inventories",
                        is_full_path:false,
                        data:data?.upload_data
                    } 
                    this.inputLoading = true 
                    if (data?.notify) {
                        ActionBus.progressDialog({
                            show:true,
                            fixed:false,
                            title:"Reloading.."
                        })  
                    }
                    const res = await ActionBus.POST_REQUEST(upload_data)
                    const body = res?.body
                    const message = body?.message 
                    this.inputLoading = false
                    ActionBus.progressDialog() 
                    if (data?.notify) {
                        let mbs_text = TextBus.item_action_success("Eis inventories","Syncing")
                        ActionBus.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:`${mbs_text.text} (${message})`,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        }) 
                    } 
                    resolve(res)
                } catch (error) { 
                    this.inputLoading = false
                    const body = error?.body
                    const message = body?.message
                    ActionBus.progressDialog() 
                    if (data?.notify) {
                        let mbs_text = TextBus.item_action_fail("Eis inventories","Syncing")
                        ActionBus.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:mbs_text.text+" ("+message+")",
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        }) 
                    }
                    reject(error)
                } 

            }) 
        }, 
        ON_LAST_SUBMITTED_ONLINE_TRANSACTION(payload){
            return new Promise(async (resolve,reject)=>{
                try {
                    const { 
                        till_key,  
                        confirm
                    } = payload || {} 
                    const selectedCompany = this.selectedCompany           
                    const company_key = selectedCompany?selectedCompany.company_key:null 
                    
                    const upload_data = {
                        company_key,
                        till_key,
                        production:DATA.EIS.production
                    } 
                    if (confirm) { 
                        let mbs_text = TextBus.item_action("Last Submitted online Transaction","GET")
                        ActionBus.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo,
                            action:{
                                code:NAME+"=LAST-SUBMITTED-ONLINE-TRANSACTION", 
                                data:{
                                    ...payload,
                                    upload_data
                                }
                            } 
                        }) 
                        resolve({
                            success:true,
                            wait_for_conformation:true
                        }) 
                        return
                    }  
                    const res = await this.LAST_SUBMITTED_ONLINE_TRANSACTION({
                        ...payload,
                        upload_data
                    })
                    const body = res?.body
                    const invoice = body?.data
                    const invoiceNumber = invoice?.invoiceHeader?.invoiceNumber 
                    const invoiceDetails =  decryptInvoiceNumber(invoiceNumber) 
                     

                    resolve({
                        response:res,
                        invoice,
                        invoiceNumber,
                        invoiceDetails
                    })
                    return
                } catch (error) { 
                    console.log(error,"ON_LAST_SUBMITTED_ONLINE_TRANSACTION............er");
                    reject(error)
                    return  
                }

            })
        }, 
        LAST_SUBMITTED_ONLINE_TRANSACTION(data){
            return new Promise(async (resolve,reject)=>{
                try {  
                    const upload_data ={
                        path:"eis-last-submitted-online-transaction",
                        is_full_path:false,
                        data:data?.upload_data
                    } 
                    this.inputLoading = true 
                    if (data?.notify) {
                        ActionBus.progressDialog({
                            show:true,
                            fixed:false,
                            title:"Reloading.."
                        })  
                    }
                    const res = await ActionBus.POST_REQUEST(upload_data)
                    const body = res?.body
                    const message = body?.message 
                    this.inputLoading = false
                    ActionBus.progressDialog() 
                    if (data?.notify) {
                        let mbs_text = TextBus.item_action_success("Last submitted online transaction","Getting..")
                        ActionBus.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:`${mbs_text.text} (${message})`,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        }) 
                    } 
                    resolve(res)
                } catch (error) { 
                    this.inputLoading = false
                    const body = error?.body
                    const message = body?.message
                    ActionBus.progressDialog() 
                    if (data?.notify) {
                        let mbs_text = TextBus.item_action_fail("Last submitted online transaction","Getting..")
                        ActionBus.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:mbs_text.text+" ("+message+")",
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        }) 
                    }
                    reject(error)
                } 

            }) 
        }, 
        ON_LAST_SUBMITTED_OFFLINE_TRANSACTION(payload){
            return new Promise(async (resolve,reject)=>{
                try {
                    const { 
                        till_key,  
                        confirm
                    } = payload || {} 
                    const selectedCompany = this.selectedCompany           
                    const company_key = selectedCompany?selectedCompany.company_key:null 
                    
                    const upload_data = {
                        company_key,
                        till_key,
                        production:DATA.EIS.production
                    } 
                    if (confirm) { 
                        let mbs_text = TextBus.item_action("Last Submitted online Transaction","GET")
                        ActionBus.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo,
                            action:{
                                code:NAME+"=LAST-SUBMITTED-OFFLINE-TRANSACTION", 
                                data:{
                                    ...payload,
                                    upload_data
                                }
                            } 
                        }) 
                        resolve({
                            success:true,
                            wait_for_conformation:true
                        }) 
                        return
                    }  
                    const res = await this.LAST_SUBMITTED_OFFLINE_TRANSACTION({
                        ...payload,
                        upload_data
                    })
                    console.log(res,"LAST_SUBMITTED_OFFLINE_TRANSACTION");
                    
                    const body = res?.body
                    const invoice = body?.data
                    const invoiceNumber = invoice?.invoiceHeader?.invoiceNumber 
                    const invoiceDetails =  decryptInvoiceNumber(invoiceNumber)
                    const transactionCount =  invoiceDetails?.transactionCount 

                     resolve({
                        response:res,
                        invoice,
                        invoiceNumber,
                        invoiceDetails
                    })
                    return
                } catch (error) { 
                    console.log(error,"ON_LAST_SUBMITTED_OFFLINE_TRANSACTION............er");
                    reject(error)
                    return  
                }

            })
        }, 
        LAST_SUBMITTED_OFFLINE_TRANSACTION(data){
            return new Promise(async (resolve,reject)=>{
                try {  
                    const upload_data ={
                        path:"eis-last-submitted-offline-transaction",
                        is_full_path:false,
                        data:data?.upload_data
                    } 
                    this.inputLoading = true 
                    if (data?.notify) {
                        ActionBus.progressDialog({
                            show:true,
                            fixed:false,
                            title:"Reloading.."
                        })  
                    }
                    const res = await ActionBus.POST_REQUEST(upload_data)
                    const body = res?.body
                    const message = body?.message 
                    this.inputLoading = false
                    ActionBus.progressDialog() 
                    if (data?.notify) {
                        let mbs_text = TextBus.item_action_success("Last submitted offline transaction","Getting..")
                        ActionBus.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:`${mbs_text.text} (${message})`,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        }) 
                    } 
                    resolve(res)
                } catch (error) { 
                    this.inputLoading = false
                    const body = error?.body
                    const message = body?.message
                    ActionBus.progressDialog() 
                    if (data?.notify) {
                        let mbs_text = TextBus.item_action_fail("Last submitted offline transaction","Getting..")
                        ActionBus.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:mbs_text.text+" ("+message+")",
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        }) 
                    }
                    reject(error)
                } 

            }) 
        }, 

 
        // async SUBMIT_EIS_RECEIPT(ctx, order) {
        //     const eis_payload  = order?.eis_payload
        //     const till         = ctx.CurrentTill
        //     const eis_terminal = till?.eis_terminal
        //     const company_key  = order?.company_key
        //     const till_key     = order?.till_key
        //     const uid          = order?.uid

        //     // ── No EIS terminal: non-fiscal sale, skip EIS entirely ───────
        //     if (!eis_terminal) {
        //         return { success: true, continue_offline: true, isEIS: false, order }
        //     }

        //     // ── Terminal present but payload missing: generation failed ────
        //     if (!eis_payload) {
        //         throw {
        //             success:          false,
        //             continue_offline: false,
        //             isEIS:            true,
        //             message:          'EIS payload is missing. Invoice generation may have failed.',
        //         }
        //     }

        //     // ── Helper: build the offline fallback order ──────────────────
        //     const offlineFallback = () => ({
        //         ...order,
        //         eis_payload: {
        //             ...eis_payload,
        //             validationURL:    eis_payload?.offline?.validationURL,
        //             uploaded:         false,
        //             submitted_online: false,
        //         },
        //     })

        //     // ── Submit to MRA (30 s hard timeout via AbortController) ─────
        //     //
        //     // timeout_ms is handled inside the http_request Vuex action using
        //     // AbortController. When the timer fires, the TCP connection is torn
        //     // down BEFORE the server processes the request — MRA never sees the
        //     // invoice, so there is no phantom submission.
        //     //
        //     // This is the critical difference vs Promise.race: race() only stops
        //     // us from *waiting*, the POST still reaches the server. abort() stops
        //     // the POST itself.
        //     try {
        //         ctx.UPDATE_EIS_INVOICE_NUMBER()

        //         console.log(order,"sale order*-----------");
                
        //         const res = await this.HTTP_REQUEST(ctx, {
        //             path:       'eis-submit-sale',
        //             timeout_ms: 30000,          // ← AbortController armed here
        //             data: {
        //                 production: DATA.EIS.production,
        //                 company_key,
        //                 till_key,
        //                 uid,
        //                 sale_order: order,
        //             },
        //         })

        //         // ── Success path ──────────────────────────────────────────
        //         const server_response               = res?.body 
        //         const mra_response                  = server_response?.mra_response
        //         const mra_response_data             = mra_response?.data
        //         const shouldBlockTerminal        = mra_response_data?.shouldBlockTerminal
        //         const shouldDownloadLatestConfig = mra_response_data?.shouldDownloadLatestConfig
        //         const validationURL              = mra_response_data?.validationURL
        //         const response_time = server_response?.response_time 
        //         const cloud_uploaded = server_response?.cloud_uploaded 

        //         console.log(server_response,'server_response................');

        //         const updated_order = {
        //             ...order,
        //             uploaded:true,
        //             eis_payload: {
        //                 ...eis_payload,
        //                 mra_response,
        //                 validationURL,
        //                 uploaded:         true,
        //                 submitted_online: true,
        //             },
        //         }

        //         if (shouldBlockTerminal) {
        //             ctx.MBS.events.$emit('EIS_CHECK_BLOCK_STATUS')
        //             ctx.BLOCK_TERMINAL(true)
        //         }
        //         if (shouldDownloadLatestConfig) {
        //             ctx.MBS.events.$emit('GET_LATEST_CONFIGURATION')
        //         }

        //         return { success: true, continue_offline: true, isEIS: true, order: updated_order }

        //     } catch (error) {
        //         // _aborted: true is set by http_request when AbortController
        //         // fires — meaning the TCP connection was cut before MRA received
        //         // the request. It is safe to go offline.
        //         const isAborted   = error?._aborted   === true
        //         const http_status = error?.error?.status
        //         const isOffline   = isAborted || http_status === 0
        //         const isB2B       = !!order?.buyerTIN

        //         // ── Aborted / no network + no buyerTIN: silent offline ────
        //         if (isOffline && !isB2B) {
        //             console.warn(
        //                 isAborted
        //                     ? '[EIS] MRA request aborted after 30 s — request was cancelled before reaching server. Falling back to offline.'
        //                     : '[EIS] Network unreachable — falling back to offline.'
        //             )
        //             return {
        //                 success:          false,
        //                 continue_offline: true,
        //                 isEIS:            true,
        //                 order:            offlineFallback(),
        //             }
        //         }

        //         // ── Aborted / no network + has buyerTIN: B2B must confirm ─
        //         if (isOffline && isB2B) {
        //             throw {
        //                 success:          false,
        //                 continue_offline: false,
        //                 isEIS:            true,
        //                 message:          isAborted
        //                     ? 'EIS submission timed out. The request was cancelled before reaching MRA. B2B invoices require a stable connection.'
        //                     : 'No network connection. B2B invoices require an online connection.',
        //             }
        //         }



        //         const server_response = error?.error?.body
        //         const server_error = server_response?.error
        //         const error_message = server_error?.message
        //         const response_time = server_response?.response_time 
        //         const cloud_uploaded = server_response?.cloud_uploaded 

        //         console.log(server_response,'server_response................');
                

        //         // ── B2C Continue error ─────────────────────
        //         if(!isB2B && (
        //             server_error?.code === 'mra_rejected' ||
        //             server_error?.code === 'connection_error' 
        //         )) {
        //             console.warn('[EIS] MRA returned a recoverable error. Falling back to offline.', server_error)
        //             return {
        //                 success:          false,
        //                 continue_offline: true,
        //                 isEIS:            true,
        //                 order:            {...offlineFallback(),uploaded:!!cloud_uploaded},
        //                 message:          'MRA Server Error. Falling back to offline.',
        //             }
        //         }

        //         // ── Server-side error: surface MRA message to the caller ──
                
        //         throw {
        //             success:          false,
        //             continue_offline: false,
        //             isEIS:            true,
        //             response:         server_response,
        //             error:            server_error,
        //             message:          error_message ?? 'Network Error.',
        //         }
        //     }
        // },
        async SUBMIT_EIS_RECEIPT(ctx, order) {
            const eis_payload  = order?.eis_payload
            const till         = ctx.CurrentTill
            const eis_terminal = till?.eis_terminal
            const company_key  = order?.company_key
            const till_key     = order?.till_key
            const uid          = order?.uid

            // ── No EIS terminal: non-fiscal sale, skip EIS entirely ───────
            if (!eis_terminal) {
                return { success: true, continue_offline: true, isEIS: false, order }
            }

            // ── Terminal present but payload missing: generation failed ────
            if (!eis_payload) {
                throw {
                    success:          false,
                    continue_offline: false,
                    isEIS:            true,
                    message:          'EIS payload is missing. Invoice generation may have failed.',
                }
            }

            // ── Helper: build the offline fallback order ──────────────────
            const offlineFallback = () => ({
                ...order,
                eis_payload: {
                    ...eis_payload,
                    validationURL:    eis_payload?.offline?.validationURL,
                    uploaded:         false,
                    submitted_online: false,
                },
            })

            const isB2B = !!order?.buyerTIN

            // ── Progressive-wait UX: own the AbortController so we can cancel
            //    early from a user action, not just at the hard timeout ───────
            const submit_started_at = Date.now()
            const controller        = new AbortController()
            let   userCancelled     = false

            const warnTimer = setTimeout(() => {
                ctx.MBS.events.$emit('EIS_SUBMIT_SLOW', {
                    elapsed_ms: Date.now() - submit_started_at,
                })
            }, 5000)

            const responseTime = res =>{
                const response_time = res?.response_time|| {}
                return {
                    ...response_time,
                    elapsed_ms: Date.now() - submit_started_at,
                }
            }

            // Only B2C gets the option to bail to offline — B2B must stay online.
            let cancelTimer = null
            if (!isB2B) {
                cancelTimer = setTimeout(() => {
                    ctx.MBS.events.$emit('EIS_SUBMIT_CANCELABLE', {
                        started_at:       submit_started_at,
                        hard_timeout_ms:  60000,
                        onCancel: () => {
                            userCancelled = true
                            controller.abort()
                        },
                    })
                }, 15000)
            }

            // Hard cutoff — same 60s ceiling as before, now enforced by us
            // rather than by http_request's internal timeout_ms.
            const hardTimer = setTimeout(() => controller.abort(), 60000)

            const clearTimers = () => {
                clearTimeout(warnTimer)
                clearTimeout(cancelTimer)
                clearTimeout(hardTimer)
                ctx.MBS.events.$emit('EIS_SUBMIT_DONE')
            }

            // ── Submit to MRA ───────────────────────────────────────────────
            try {
                ctx.UPDATE_EIS_INVOICE_NUMBER()

                const res = await this.HTTP_REQUEST(ctx, {
                    path:   'eis-submit-sale',
                    signal: controller.signal,   // ← replaces timeout_ms
                    data: {
                        production: DATA.EIS.production,
                        company_key,
                        till_key,
                        uid,
                        sale_order: order,
                    },
                })

                clearTimers()

                // ── Success path ──────────────────────────────────────────
                const server_response            = res?.body
                const response_time              = responseTime(server_response) 
                const cloud_uploaded             = server_response?.cloud_uploaded
                const mra_response               = server_response?.mra_response
                const mra_response_data          = mra_response?.data
                const shouldBlockTerminal        = mra_response_data?.shouldBlockTerminal
                const shouldDownloadLatestConfig = mra_response_data?.shouldDownloadLatestConfig
                const validationURL              = mra_response_data?.validationURL

                const updated_order = {
                    ...order,
                    response_time,
                    cloud_uploaded,
                    eis_payload: {
                        ...eis_payload,
                        mra_response,
                        validationURL,
                        uploaded:         true,
                        submitted_online: true,
                    },
                }

                if (shouldBlockTerminal) {
                    ctx.MBS.events.$emit('EIS_CHECK_BLOCK_STATUS')
                    ctx.BLOCK_TERMINAL(true)
                }
                if (shouldDownloadLatestConfig) {
                    ctx.MBS.events.$emit('GET_LATEST_CONFIGURATION',{show_snack:true})
                }

                return { 
                    success: true,
                    response_time, 
                    continue_offline: true, 
                    isEIS: true, 
                    order: updated_order,
                   
                }

            } catch (error) {
                clearTimers()

                console.log(error,"eee...");
                
                const server_response = error?.error?.body
                const server_error    = server_response?.error
                const error_message   = server_error?.message
                const cloud_uploaded  = server_response?.cloud_uploaded
                const response_time              = responseTime(server_response) 

                const isAborted   = error?._aborted === true || controller.signal.aborted
                const http_status = error?.error?.status
                const isOffline    = isAborted || http_status === 0
                

                // ── Aborted / no network + no buyerTIN: silent offline ────
                if (isOffline && !isB2B) {
                    console.warn(
                        userCancelled
                            ? '[EIS] Submission cancelled by cashier — falling back to offline.'
                            : isAborted
                                ? '[EIS] MRA request aborted — timed out before reaching server. Falling back to offline.'
                                : '[EIS] Network unreachable — falling back to offline.'
                    )
                    return {
                        success:          false,
                        continue_offline: true,
                        isEIS:            true,
                        order:            offlineFallback(),
                        response_time,
                        message:"Network error. Falling back to offline."
                    }
                }

                // ── Aborted / no network + has buyerTIN: B2B must confirm ─
                if (isOffline && isB2B) {
                    throw {
                        response_time,
                        success:          false,
                        continue_offline: false,
                        isEIS:            true,
                        message:          isAborted
                            ? 'EIS submission timed out. The request was cancelled before reaching MRA. B2B invoices require a stable connection.'
                            : 'No network connection. B2B invoices require an online connection.',
                    }
                }

                

                // ── B2C Continue error ─────────────────────
                if (!isB2B && (
                    server_error?.code === 'mra_rejected' ||
                    server_error?.code === 'connection_error'
                )) {
                    console.warn('[EIS] MRA returned a recoverable error. Falling back to offline.', server_error)
                    return {
                        response_time,
                        success:          false,
                        continue_offline: true,
                        isEIS:            true,
                        order:            { ...offlineFallback(), uploaded: !!cloud_uploaded },
                        message:          'MRA Server Error. Falling back to offline.',
                    }
                }

                // ── Server-side error: surface MRA message to the caller ──
                throw {
                    response_time,
                    success:          false,
                    continue_offline: false,
                    isEIS:            true,
                    response:         server_response,
                    error:            server_error,
                    message:          error_message ?? 'Network Error.',
                }
            }
        },
        async HTTP_REQUEST(ctx, payload) {
            return ctx.$store.dispatch('http_request', payload)
        },

        //----------------[MAIN FUNCTIONS]------------------//
        DIALOG_YES(action){
            try {  
                let code = action.code
                if (action) {  
                    if (code===NAME+"=SYNC-EIS-PRODUCTS") { 
                        if (action.YES) {
                            setTimeout(() => {
                                this.SYNC_EIS_PRODUCTS(action.data)
                            }, 100);  
                        }else{
                            
                        }
                    }
                    if (code===NAME+"=SYNC-EIS-INVENTORIES") { 
                        if (action.YES) {
                            setTimeout(() => {
                                this.SYNC_EIS_INVENTORIES(action.data)
                            }, 100);  
                        }else{
                            
                        }
                    }
                    if (code===NAME+"=LAST-SUBMITTED-ONLINE-TRANSACTION") { 
                        if (action.YES) {
                            setTimeout(() => {
                                this.LAST_SUBMITTED_ONLINE_TRANSACTION(action.data)
                            }, 100);  
                        }else{
                            
                        }
                    } 
                    if (code===NAME+"=LAST-SUBMITTED-OFFLINE-TRANSACTION") { 
                        if (action.YES) {
                            setTimeout(() => {
                                this.LAST_SUBMITTED_OFFLINE_TRANSACTION(action.data)
                            }, 100);  
                        }else{
                            
                        }
                    }  
                } 
            } catch (error) {
                this.error({
                    error:error,
                    from:'DIALOG_YES',
                    page:NAME, 
                })
            }
        },
         
    },
    beforeDestroy(){
        try { 
            this.MBS.events.$off('DIALOG_YES', this.DIALOG_YES);    
        } catch (error) {
            this.error({
                error:error,
                from:'beforeDestroy',
                page:NAME, 
            })
        }  
    },
    watch: {
        us(v){
           
        }, 
    },
});
